import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHourglass: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"hourglass"} maskId="square-filled-radius-0-stroke-1-IconHourglass"><path fillRule="evenodd" clipRule="evenodd" d="M21 2V3H19V8.02047L12.9137 12L19 15.9795V21H21V22H3V21H5V15.9795L11.0863 12L5 8.02047V3H3V2H21ZM6 3V7H18V3H6ZM18 18V16.5205L12 12.5974L6 16.5205V18H18Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHourglass;
